import { useTranslation } from 'react-i18next';
import { useFloatNotification } from 'contexts/FloatNotificationContext';
import { ErrorType } from 'types/genericTypes';
import { Report } from 'types/reportTypes';
import { GenericDeleteModal } from 'components/ui/GenericDeleteModal';
import { useDeleteTransaction } from 'api/services/reportsService';

type DeleteTransactionModalProps = {
  displayDeleteModal: boolean;
  onCancel: () => void;
  transaction: Report | undefined;
};

export const DeleteTransactionModal = ({
  displayDeleteModal,
  onCancel,
  transaction,
}: DeleteTransactionModalProps) => {
  const { t } = useTranslation();
  const { mutateAsync: deleteTransaction } = useDeleteTransaction();
  const { openNotification } = useFloatNotification();

  const handleDeleteTransaction = async () => {
    try {
      await deleteTransaction({
        transactionId: transaction?.transactionId || '',
      });

      openNotification(
        t('success'),
        t('transactions.delete-modal.delete-success'),
        'success'
      );
    } catch (err) {
      const apiError = err as ErrorType;
      if (apiError.body?.errorCode) {
        openNotification(t('error'), t(apiError.body.errorCode), 'error');
      } else {
        openNotification(
          t('error'),
          t('transactions.delete-modal.delete-error'),
          'error'
        );
      }
    }

    onCancel();
  };

  return (
    <GenericDeleteModal
      open={displayDeleteModal}
      onCancel={onCancel}
      onOk={handleDeleteTransaction}
      bodyTitle={t('transactions.delete-modal.title')}
      bodyText={t('transactions.delete-modal.body')}
    />
  );
};
